import React, { useState, useEffect } from 'react'

import { Table, Card, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ArrowClockwise, CaretDown, CaretUp } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faUserPlus,
  faCheck,
  faEdit,
  faEyeDropper,
} from '@fortawesome/free-solid-svg-icons'

import { CustomButton } from '../../components/CustomButton'
import { CustomSpinner } from '../../components/CustomSpinner'
import Navbar from '../../components/navbar/navbar'

import apinode from '../../services/apinode'

import { useOrderTable } from '../../hooks/useOrderTable'

import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

import { ModalAdicionarUsuario } from './ModalAdicionarUsuario'
import { ModalContagem } from './ModalContagem'
import { ModalCriarInventario } from './ModalCriarInventario'
import { ModalEditarInventario } from './ModalEditarInventario'

import './styles.css'
import { Center } from '../../components/Center'

function Inventories() {
  const [inventories, setInventories] = useState([])
  const [selectedInventory, setSelectedInventory] = useState(null)
  const [selectedInventoryId, setSelectedInventoryId] = useState(null)

  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [isAddUsersModalOpen, setIsAddUsersModalOpen] = useState(false)
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)
  const [isCountModalOpen, setIsCountModalOpen] = useState(false)
  const [isLoadingInventories, setIsLoadingInventories] = useState(true)

  const [isRequestFinishLoading, setIsRequestFinishLoading] = useState({})

  const {
    check,
    handleOrganize,
    sortedArray: sortedInventories,
  } = useOrderTable(inventories, 'ID')

  async function handleFinishInventory(id) {
    try {
      setIsRequestFinishLoading((prevState) => ({
        ...prevState,
        [id]: true,
      }))

      console.log(id)

      await apinode.put(
        `inventario/inventWagnerInputar/${localStorage.idconta}/${id}`,
      )

      toast.success('Inventário finalizado com sucesso!')
      loadInventories()
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível finalizar o inventário!')
    } finally {
      setIsRequestFinishLoading((prevState) => ({
        ...prevState,
        [id]: false,
      }))
    }
  }

  const handleSaveInventoryChanges = (editedInventory) => {
    setInventories((prevList) =>
      prevList.map((inventory) =>
        inventory.ID === editedInventory.ID ? editedInventory : inventory,
      ),
    )

    setIsEditModalOpen(false)
  }

  async function loadInventories() {
    try {
      setIsLoadingInventories(true)

      const response = await apinode.get(
        `inventario/consultaInvent/${localStorage.idconta}`,
      )

      setInventories(response.data)
    } catch (error) {
      console.error('Erro ao buscar inventários:', error)
    } finally {
      setIsLoadingInventories(false)
    }
  }

  useEffect(() => {
    loadInventories()
  }, [])

  return (
    <>
      <Navbar />

      <div className=" mt-page">
        <Card>
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-3 ml-auto">
              <h2 className="mb-0">Configuração de Inventário</h2>

              <div
                style={{
                  display: 'flex',
                }}
              >
                <CustomButton
                  title="Atualizar"
                  onClick={loadInventories}
                  isLoading={isLoadingInventories}
                  isLoadingText="Atualizando..."
                >
                  <ArrowClockwise />
                </CustomButton>

                <button
                  className="btn btn-success btn-sm d-none d-md-block"
                  onClick={() => {
                    setIsCreateModalOpen(true)
                  }}
                >
                  Novo Inventário
                </button>
              </div>
            </div>

            <div className="mt-5 ms-4 me-4">
              {isLoadingInventories ? (
                <Center>
                  <CustomSpinner />
                </Center>
              ) : sortedInventories.length === 0 && !isLoadingInventories ? (
                <p>Sem inventários disponíveis!</p>
              ) : (
                <Table
                  striped
                  bordered
                  hover
                  responsive
                  className="table"
                >
                  <thead className="bg-secondary">
                    <tr>
                      <th
                        onClick={() => handleOrganize('ID')}
                        className="text-dark"
                      >
                        <span>ID</span>
                        <CaretUp color={check('ID', 'asc')} />
                        <CaretDown color={check('ID', 'desc')} />
                      </th>
                      <th
                        onClick={() => handleOrganize('DESCRICAO')}
                        className="text-dark"
                      >
                        <span>DESCRIÇÃO</span>
                        <CaretUp color={check('DESCRICAO', 'asc')} />
                        <CaretDown color={check('DESCRICAO', 'desc')} />
                      </th>
                      <th className="text-dark">TIPO</th>
                      <th className="text-dark">STATUS</th>
                      <th className="text-dark">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedInventories.map((inventory) => (
                      <tr key={inventory.ID}>
                        <td>{inventory.ID}</td>
                        <td>{inventory.DESCRICAO}</td>
                        <td>{inventory.TIPO}</td>
                        <td>
                          {inventory.STATUS === 'A' ? (
                            <span className="badge bg-success">Aberto</span>
                          ) : inventory.STATUS === 'F' ? (
                            <span className="badge bg-secondary">
                              Finalizado
                            </span>
                          ) : null}
                        </td>

                        <td>
                          <div
                            className="btn-group"
                            role="group"
                          >
                            <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                              <button
                                className="btn btn-primary btn-sm mr-1"
                                onClick={() => {
                                  setSelectedInventory(inventory)
                                  setIsEditModalOpen(true)
                                }}
                              >
                                <FontAwesomeIcon icon={faEdit} />
                              </button>
                            </OverlayTrigger>

                            <OverlayTrigger
                              overlay={<Tooltip>Adicionar Usuários</Tooltip>}
                            >
                              <button
                                className="btn btn-warning btn-sm mr-1"
                                title="Adicionar Usuários"
                                onClick={() => {
                                  setSelectedInventoryId(inventory.ID)
                                  setIsAddUsersModalOpen(true)
                                }}
                              >
                                <FontAwesomeIcon icon={faUserPlus} />
                              </button>
                            </OverlayTrigger>

                            <OverlayTrigger
                              overlay={<Tooltip>Visualizar Contagem</Tooltip>}
                            >
                              <button
                                className="btn btn-info btn-sm mr-1"
                                title="Visualizar Contagem"
                                onClick={() => {
                                  setSelectedInventoryId(inventory.ID)
                                  setIsCountModalOpen(true)
                                }}
                              >
                                <FontAwesomeIcon icon={faEyeDropper} />
                              </button>
                            </OverlayTrigger>

                            <OverlayTrigger
                              overlay={<Tooltip>Finalizar Inventário</Tooltip>}
                            >
                              <CustomButton
                                isLoading={isRequestFinishLoading[inventory.ID]}
                                color="#198754"
                                disabled={inventory.STATUS === 'F'}
                                onClick={() =>
                                  handleFinishInventory(inventory.ID)
                                }
                              >
                                <FontAwesomeIcon icon={faCheck} />
                              </CustomButton>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </div>
          </Card.Body>
        </Card>
      </div>

      {isCountModalOpen && (
        <ModalContagem
          selectedInventoryId={selectedInventoryId}
          isOpen={isCountModalOpen}
          onClose={() => setIsCountModalOpen(false)}
        />
      )}

      {isCreateModalOpen && (
        <ModalCriarInventario
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
          loadInventories={loadInventories}
          setInventories={setInventories}
        />
      )}

      {isEditModalOpen && (
        <ModalEditarInventario
          isOpen={isEditModalOpen}
          inventory={selectedInventory}
          onSave={handleSaveInventoryChanges}
          onClose={() => setIsEditModalOpen(false)}
        />
      )}

      {isAddUsersModalOpen && (
        <ModalAdicionarUsuario
          isOpen={isAddUsersModalOpen}
          onClose={() => setIsAddUsersModalOpen(false)}
          selectedInventoryId={selectedInventoryId}
          loadInventories={loadInventories}
          setInventories={setInventories}
        />
      )}
    </>
  )
}

export default Inventories
